<template>
  <div class="text-center text-md-left">
    <p class="title-soc-block">
      {{Lang.get('js.share')}}
    </p>
    <div class="share-buttons-list">
            <span v-for="(social,index) in socials"
                  class="transition"
                  :class="index"
                  :title="social"
                  @click="share(index)"
                  v-text="social">
            </span>
    </div>
  </div>

</template>

<script>
    export default {
        name: "share-buttons",
        data() {
            return {
                socials: {
                    vk: 'vkontakte',
                    facebook: 'facebook',
                    od: 'odnoklassniki',
                    mailRu: 'Мой Мир',
                    // telegram: 'telegram',
                    viber: 'viber',
                    whatsApp: 'whatsApp',
                    twitter: 'twitter',
                    // gPlus: 'google plus',
                },
                links: {
                    vk: 'http://vk.com/share.php?url=[URL]&title=[TITLE]&description=[DESC]&image=[IMAGE]&noparse=true',
                    facebook: 'https://www.facebook.com/sharer/sharer.php?u={0}',
                    mailRu: 'http://connect.mail.ru/share?url=[URL]&title=[TITLE]&description=[DESC]&imageurl=[IMAGE]',
                    // telegram: 'https://t.me/share/url?url={0}&text={1}',
                    viber: 'viber://forward?text= ',
                    whatsApp: 'https://api.whatsapp.com/send?text={1}{0}',
                    twitter: 'https://twitter.com/intent/tweet?text={1}&url={0}&related=',
                    // gPlus: 'https://plus.google.com/share?url={0}&text={1}',
                },
                Lang,
            }
        },
        methods: {
            // share(type) {
            //     let title = document.title.replace('|', ' ') + ' ';
            //
            //     let str = this.links[type].format(location, title);
            //
            //     this.showPopup(str);
            // },
            share(type) {
    
                if (type === 'vk') {
                    let url = window.location.href;
                    let str = 'http://vk.com/share.php?url=' + url + '&title=[TITLE]&description=[DESC]&image=[IMAGE]&noparse=true';
                    this.showPopup(str);
                }
                else if(type === 'od')
                {
                    let url = window.location.href;
                    let str = 'https://connect.ok.ru/offer?url=' + url + '&title=[TITLE]&imageUrl=IMAGE_URL';
                    this.showPopup(str);
                }
                else if (type === 'viber') {
                    let url = window.location.href;
                    let str = 'viber://forward?text= ' + url;
                    this.showPopup(str);
                } else if (type === 'facebook') {
                    let url = window.location.href;
                    let str = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
                    this.showPopup(str);
                }
                else if(type === 'mailRu') {
                    let url = window.location.href;
                    let str = 'http://connect.mail.ru/share?url=' + url + '&title=[TITLE]&description=[DESC]&imageurl=[IMAGE]';
                    this.showPopup(str);
                }
                // else if (type == 'telegram') {
                //     let url = window.location.href;
                //     let str = 'https://t.me/share/url?url=' + url;
                //     this.showPopup(str);
                // }
                else if (type === 'whatsApp') {
                    let url = window.location.href;
                    let str = 'https://api.whatsapp.com/send?text=' + url;
                    this.showPopup(str);
                } else if (type === 'twitter') {
                    let url = window.location.href;
                    let str = 'https://twitter.com/intent/tweet?url=' + url;
                    this.showPopup(str);
                }
    
            },
            showPopup(url) {
                let windowWidth = 600;
                let windowHeight = 400;

                let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
                let dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

                let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
                let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

                let systemZoom = width / window.screen.availWidth;
                let left = (width - windowWidth) / 2 / systemZoom + dualScreenLeft;
                let top = (height - windowHeight) / 2 / systemZoom + dualScreenTop;

                let windowFormat = 'scrollbars=yes,width={0},height={1},top={2},left={3}'.format(windowWidth, windowHeight, top, left);

                let newWindow = window.open(url, '', windowFormat);

                if (window.focus) {
                    newWindow.focus();
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// resources/js/components/elements/ShareButtons.vue